/**
 * <s-hint-share data-url="…" data-text="…" data-copied-label="…">
 * "Drop a hint" on the Chanukah Gift Guide. Clicking the [data-share-button] inside opens the phone's share sheet
 * (iMessage, WhatsApp…) with data-text and data-url. Where sharing isn't available (most desktops) it copies
 * "text url" to the clipboard and briefly swaps [data-share-label] to data-copied-label.
 */
class SHintShare extends HTMLElement {
  connectedCallback() {
    this.handleClick = (event) => {
      const button = event.target.closest('[data-share-button]');
      if (!button || !this.contains(button)) return;
      this.share();
    };
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    clearTimeout(this.resetTimer);
  }

  async share() {
    const url = this.dataset.url || window.location.href;
    const text = this.dataset.text || '';
    if (navigator.share) {
      try {
        await navigator.share({ text, url });
      } catch (error) {
        // Closing the share sheet is not an error worth surfacing.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(`${text} ${url}`.trim());
      this.showCopied();
    } catch (error) {
      window.location.href = `sms:?&body=${encodeURIComponent(`${text} ${url}`.trim())}`;
    }
  }

  showCopied() {
    const label = this.querySelector('[data-share-label]');
    const copied = this.dataset.copiedLabel;
    if (!label || !copied) return;
    if (!this.originalLabel) this.originalLabel = label.textContent;
    label.textContent = copied;
    clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      label.textContent = this.originalLabel;
    }, 2000);
  }
}

if (!customElements.get('s-hint-share')) customElements.define('s-hint-share', SHintShare);
